<!DOCTYPE html>
<html lang="en" translate="no">

<head>
  <meta charset="utf-8" />
  <link rel="icon" href="/favicon.ico" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <meta name="theme-color" content="#000000" />
  <meta name="description"
    content="XorMon performance monitoring for server, storage, cloud, container, backup, DB, SAN and LAN" />
  <!--
      manifest.json provides metadata used when your web app is installed on a
      user's mobile device or desktop. See https://developers.google.com/web/fundamentals/web-app-manifest/
    -->
  <link rel="manifest" href="/manifest.json" />
  <script>
    var publicUrl;
  </script>
  <title>XorMon</title>
</head>

<body>
  <noscript>You need to enable JavaScript to run this app.</noscript>
  <div id="textMeasure"></div>
  <div id="root"></div>
  <!--
      This HTML file is a template.
      If you open it directly in the browser, you will see an empty page.

      You can add webfonts, meta tags, or analytics to this file.
      The build step will place the bundled scripts into the <body> tag.

      To begin the development, run `npm start` or `yarn start`.
      To create a production bundle, use `npm run build` or `yarn build`.
    -->

  <script type="module" src="/src/index.tsx"></script>
</body>

</html>
